export const COST_TYPES = Object.freeze({
  PER_SLOT: "PerSlot",
  PER_ITEM: "PerItem",
  PER_SIGNUP: "PerSignup",
});
